export * from "./users-profile.component";
export * from "./users-profile.module";


// WEBPACK FOOTER //
// ./src/app/users-profile/index.ts